type ReportTableRowProps = {
    id: string;
    name: string;

    value: string;

    width: number;

    color: string;

    average?: string;
    showAverage: boolean;

    date: string;
    isValid: boolean;
};

export default function ReportTableRow({
    id,
    name,

    value,

    width,

    color,

    average,
    showAverage,

    date,
    isValid,
}: Readonly<ReportTableRowProps>) {

    let bar = <></>;

    if (isValid) {
        bar = <canvas id={`canvas-${id}`} width={width} height="10" className={color}></canvas>;
    }

    return (
        <tr key={`report-table-row-${id}`} className="report-table-row">
            <td className="report-table-row--name" title={name}>
                <span className="report-table-row--name-text">{name}</span>
            </td>
            <td className="report-table-row--val" title={value}>
                <span className="report-table-row--value-extend">
                    {value}
                </span>
            </td>
            <td className="report-table-row--bar">
                {bar}
            </td>
            <td className="report-table-row--date" title={date}>
                {date}
            </td>
            {showAverage && (
                <td className="report-table-row--avg" title={`${average}`}>
                    {average}
                </td>
            )}
        </tr>
    );
}
